/* import { Routes, Route } from 'react-router-dom';
import PrintingRequest from './pages/docPrinting'
import ResetPassword from './pages/ResetPassword';
import UserHome from './pages/UserHome';
import Register from './pages/Register';
import Login from './pages/Login';
import PrivateRoute from './context/PrivateRoute';

const App = () => {
  return (
    <Routes>
      <Route path="/resetpassword" element={<ResetPassword/>} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      
      <Route path="/PrintRequest" element={<PrintingRequest />} />

      <Route path="/userhome" element=
        {
          < PrivateRoute >
            <UserHome />
          </PrivateRoute >
        } 
      />
    </Routes>
  );
};

export default App; */

import { Routes, Route } from 'react-router-dom';
import LoginSignup from "./pages/LoginSignup";
import PrintingRequest from "./pages/docPrinting";
import SiteDomainBanner from "./components/SiteDomainBanner";

function App() {
  return (
    <>
      <SiteDomainBanner />
      <div className="app-main app-main--with-domain-banner">
        <Routes>
          <Route path="/" element={<LoginSignup />} />
          <Route path="/PrintRequest" element={<PrintingRequest />} />
        </Routes>
      </div>
    </>
  );
}

export default App;

